/*
    Copyright (c) Computer-L.A.N. GmbH (http://www.computer-lan.de).
    Alle Rechte vorbehalten.
*/

import { Accept } from "react-dropzone";
import FileExtension, { mimeTypeMap } from "./FileExtensions";
import FileUpload from "./FileUpload";

export function toFile(fileUpload: FileUpload): File {
    return new File(
        [new Uint8Array(fileUpload.data)],
        fileUpload.name,
        { type: fileUpload.contentType });
}


export async function toFileUpload(file: File): Promise<FileUpload> {
    const arrayData = await new Response(file).arrayBuffer();
    return {
        name: file.name,
        contentType: file.type,
        data: Array.from(new Uint8Array(arrayData)),
    };
}

export function toAccept(extensions: FileExtension[]) {
    return extensions.reduce((accept, ext) => {
        if (!Array.isArray(accept[mimeTypeMap[ext]])) {
            accept[mimeTypeMap[ext]] = [];
        }

        accept[mimeTypeMap[ext]].push(ext);
        return accept;
    }, {} as Accept);
}